import img from "../assests/images/South-Travels-Logo.png";
import img2 from "../assests/images/South-Travels-Footer-Logo.png";

import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Percent,
  Plane,
  Hotel,
  PhoneCall,
  Mail,
} from "lucide-react";

export default function Header({
  onLoginClick,
  user,
  setUser,
}) {
  const [dropdownOpen, setDropdownOpen] =
    useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] =
    useState(false);

  const dropdownRef = useRef();
  const mobileMenuRef = useRef();

  const navigate = useNavigate();

  const [mobileUserOpen, setMobileUserOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }

      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigateTop = () => {
    window.scrollTo(0, 0);
  };

  const navLinkClass = ({ isActive }) =>
    `relative font-medium transition
    text-base md:text-sm lg:text-sm py-2 ${isActive
      ? "text-[#FF6B35]"
      : "text-gray-700 hover:text-[#FF6B35]"
    }`;

  const handleMobileNavClick = () => {
    setMobileMenuOpen(false);
  };

  const navItems = (
    <>
      <NavLink to="/" className={navLinkClass} onClick={navigateTop}>
        Home
      </NavLink>

      <NavLink to="/hotels" className={navLinkClass}>
        Hotels
      </NavLink>

      <NavLink to="/about-us" className={navLinkClass} onClick={handleMobileNavClick}>
        About Us
      </NavLink>

      <NavLink to="/services" className={navLinkClass} onClick={handleMobileNavClick}>
        Services
      </NavLink>

      <NavLink to="/blogs" className={navLinkClass}>
        Blog
      </NavLink>

      <NavLink to="/contact-us" className={navLinkClass}>
        Contact
      </NavLink>
    </>
  );

  return (
    <>
      {/* Top Bar (unchanged) */}
      <div className="bg-gradient-to-r from-[#FF6B35] to-[#ff7a45] text-white text-xs overflow-hidden">
        <div className="max-w-screen-2xl mx-auto px-4 py-3 flex">
          <div className="flex whitespace-nowrap animate-[marquee_20s_linear_infinite] gap-12">
            <span className="flex items-center gap-2 font-medium">
              <Percent size={15} />
              Summer Sale: <span className="font-semibold">Save up to 60%</span> on Dubai Hotels
            </span>

            <span className="flex items-center gap-2">
              <Plane size={15} />
              Best Flight Deals Available Today
            </span>

            <span className="flex items-center gap-2">
              <Hotel size={15} />
              Free Cancellation on Selected Hotels
            </span>

            <a href="tel:+971501234567" className="flex items-center gap-2 hover:text-white/80 transition">
              <PhoneCall size={15} />
              +971 50 123 4567
            </a>

            <a href="mailto:info@southtravels.com" className="flex items-center gap-2 hover:text-white/80 transition">
              <Mail size={15} />
              info@southtravels.com
            </a>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-sm py-1">
        <div className="max-w-screen-2xl mx-auto px-6">
          <div className="h-[80px] flex items-center justify-between">

            {/* Logo */}
            <NavLink to="/" className="flex items-center gap-3">
              <img src={img} alt="Dubai Cheap Hotels" />
            </NavLink>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              {navItems}
            </div>

            {/* Right Side */}
            <div className="hidden lg:flex items-center gap-4">

              <NavLink
                to="/wishlist"
                className="hidden lg:flex items-center gap-2 bg-pink-50 text-pink-600 px-3 py-2 rounded-full text-sm"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  />
                </svg>
                Wishlist
              </NavLink>

              {!user ? (
                <button
                  onClick={onLoginClick}
                  className="px-5 py-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300"
                >
                  Login
                </button>
              ) : (
                <div className="relative" ref={dropdownRef}>
                  <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="flex items-center gap-3 border border-orange-200 rounded-xl px-4 py-2 hover:border-[#FF6B35] hover:shadow-md transition"
                  >
                    <div className="w-8 h-8 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] rounded-full flex items-center justify-center text-white font-semibold shadow-md">
                      {user.name.charAt(0)}
                    </div>

                    <span>{user.name.split(" ")[0]}</span>
                  </button>

                  {dropdownOpen && (
                    <div className="absolute right-0 mt-2 w-52 bg-white shadow-2xl border-r border-orange-100 border border-orange-100 rounded-2xl overflow-hidden">
                      <NavLink to="/profile" className="block px-4 py-3 hover:bg-orange-50 hover:text-[#FF6B35] transition">
                        My Profile
                      </NavLink>

                      <NavLink to="/wishlist" className="block px-4 py-3 hover:bg-orange-50 hover:text-[#FF6B35] transition">
                        Wishlist
                      </NavLink>

                      <button
                        onClick={() => {
                          localStorage.removeItem("user");
                          setUser(null);
                          navigate("/");
                          setDropdownOpen(false);
                        }}
                        className="w-full text-left px-4 py-3 text-red-500 hover:bg-red-50 transition"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Mobile Button (unchanged) */}
            <div className="lg:hidden" ref={mobileMenuRef}>
              {/* MENU BUTTON */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="w-11 h-11 flex items-center justify-center rounded-xl border border-orange-200 bg-white shadow-sm hover:shadow-md transition"
              >
                <svg
                  className="w-6 h-6 text-[#FF6B35]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>

              {/* OVERLAY */}
              <div
                onClick={() => setMobileMenuOpen(false)}
                className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300 ${mobileMenuOpen
                  ? "opacity-100 visible"
                  : "opacity-0 invisible"
                  }`}
              />

              {/* SIDEBAR */}
              <div
                className={`fixed top-0 left-0 w-screen bg-white shadow-[0_0_40px_rgba(0,0,0,0.15)] z-50 transition-transform duration-300 overflow-y-auto max-h-screen ${mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
                  }`}
              >
                {/* HEADER */}
                <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] px-6 py-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <NavLink to="/" className="flex items-center gap-3">
                        <img src={img2} alt="Dubai Cheap Hotels" />
                      </NavLink>

                    </div>

                    <button
                      onClick={() => setMobileMenuOpen(false)}
                      className="w-10 h-10 rounded-full bg-white/20 text-white flex items-center justify-center hover:bg-white/30 transition"
                    >
                      ✕
                    </button>
                  </div>
                </div>

                {/* USER SECTION */}
                <div className="px-6 py-3 border-b border-gray-100 relative">
                  {user ? (
                    <>
                      {/* USER BUTTON */}
                      <button
                        onClick={() => setMobileUserOpen(!mobileUserOpen)}
                        className="flex items-center gap-4 w-full"
                      >
                        <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] flex items-center justify-center text-white font-bold text-lg shadow-md">
                          {user.name.charAt(0)}
                        </div>

                        <div className="text-left">
                          <p className="text-base font-semibold text-gray-800">
                            {user.name}
                          </p>
                          <p className="text-xs text-gray-500">
                            Tap to manage account
                          </p>
                        </div>
                      </button>

                      {/* DROPDOWN */}
                      {mobileUserOpen && (
                        <div className="mt-2 bg-white border border-gray-100 rounded-xl shadow-md overflow-hidden">

                          <NavLink
                            to="/profile"
                            onClick={() => {
                              setMobileUserOpen(false);
                              setMobileMenuOpen(false);
                            }}
                            className="block px-4 py-3 hover:bg-orange-50 hover:text-[#FF6B35]"
                          >
                            My Profile
                          </NavLink>

                          <NavLink
                            to="/wishlist"
                            onClick={() => {
                              setMobileUserOpen(false);
                              setMobileMenuOpen(false);
                            }}
                            className="block px-4 py-3 hover:bg-orange-50 hover:text-[#FF6B35]"
                          >
                            Wishlist
                          </NavLink>

                          <button
                            onClick={() => {
                              localStorage.removeItem("user");
                              setUser(null);
                              setMobileUserOpen(false);
                              setMobileMenuOpen(false);
                              navigate("/");
                            }}
                            className="w-full text-left px-4 py-3 text-red-500 hover:bg-red-50"
                          >
                            Logout
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <button
                      onClick={() => {
                        onLoginClick();
                        setMobileMenuOpen(false);
                      }}
                      className="w-full py-3 rounded-xl bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-semibold"
                    >
                      Login / Sign Up
                    </button>
                  )}
                </div>




                {/* MENU ITEMS */}
                <div className="px-6 pb-4">
                  <div className="flex flex-col">
                    {React.Children.map(navItems, (item, index) => (
                      <div
                        key={index}
                        className="w-full py-4 border-b border-gray-100 flex flex-col"
                      >
                        {item}
                      </div>
                    ))}
                  </div>

                  {/* LOGIN BUTTON */}
                  {!user && (
                    <div className="mt-8">
                      <button
                        onClick={() => {
                          onLoginClick();
                          setMobileMenuOpen(false);
                        }}
                        className="w-full py-3.5 rounded-xl bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-semibold shadow-md hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
                      >
                        Login / Sign Up
                      </button>
                    </div>
                  )}


                </div>
              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  );
}